import util from '../util'

let controller = 'Dashboard'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
  ObterPorGrupo: function (dto) {
    return util.Axios.GetAll(controller + '/PorGrupo', dto)
  }
})
